// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params && params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("tax-rates", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: params ? params.search : null,
        filter: params ? params.filter : null,
      })
        .then(({ data }) => {
          context.commit("set_taxRates", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  getByLocation(context, locationId) {
    return new Promise((resolve,reject) => {
      NewApiService.get("tax-rates/by-location", {
        locationId
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    });
  },
  get(context, taxRateId) {
    return new Promise((resolve,reject) => {
      NewApiService.get(`tax-rates/${taxRateId}`)
        .then(({ data }) => {
          resolve(data.tax_rate);
        })
        .catch(({ response }) => {
          reject(response)
        });
    });
  },
  add(context, model) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("tax-rates", model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    });
  },
  update(context, model) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("tax-rates/" + model.id, model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    });
  },
  delete(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete("tax-rates/" + params.model.id)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  }
};
